export function ExportEmailInvoiceItemCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  company,
  end_date,
  limited,
  messages,
  start_date,
  workshopAPI,
) {
  $scope.company     = company;
  $scope.end_date    = end_date;
  $scope.export_type = $translate.instant('INVOICE_SPACE.INVOICE_ITEM');
  $scope.limited     = limited;
  $scope.start_date  = start_date;

  $scope.email_export = function () {
    const url = $scope.limited ? '/invoice_items/invoice_item_csv_customer_export'  : '/invoice_items/invoice_item_csv_admin_export';

    workshopAPI.post(url, {
      email: $scope.email,
      start_date: $scope.start_date,
      end_date: $scope.end_date,
      company_id: $scope.company.id
    }, 'invoice_data').then(() => {
      messages.show($translate.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {email: $scope.email}), 'success');
      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };
}